<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body mb-0 pb-0">
                        <div
                            v-if="status.list && !loading"
                            class="row"
                        >
                            <div class="col-lg-3 mb-0 pb-0">
                                <div class="card shadow-sm">
                                    <b-form-input
                                        v-model="filter"
                                        class="form-control mb-3"
                                        type="search"
                                        :placeholder="$t('label.search')"
                                        v-on:change="searchListing"
                                        autocomplete="off"
                                    />
                                    <div class="candidate-list-scroll">
                                        <template>
                                            <div
                                                v-for="(item, index) in tableRows"
                                                :key="index"
                                                :class="[
                                                    'card shadow-sm mb-2 candidate-card cursor-pointer fade-in position-relative overflow-hidden',
                                                    selectedCandidate && selectedCandidate.uuid == item.uuid ? 'border border-secondary shadow-lg' : 'border border-transparent'
                                                ]"
                                                @click="selectedCandidateUUID = item.uuid; candidateTabActive = 1;"
                                            >
                                                <div
                                                    v-if="item.isDuplicated"
                                                    class="ribbon-wrapper"
                                                >
                                                    <div class="ribbon font-weight-bold text-uppercase h6">
                                                        Duplicated
                                                    </div>
                                                </div>
                                                <div class="m-2">
                                                    <div class="d-flex align-items-start">
                                                        <div class="flex-grow-1">
                                                            <h6 class="font-weight-bold">
                                                                {{ `${item.firstName || ''} ${item.lastName || ''}`.trim().length > 25 ? `${`${item.firstName || ''} ${item.lastName || ''}`.trim().substring(0, 25)}...` : `${item.firstName || ''} ${item.lastName || ''}`.trim() }}
                                                            </h6>
                                                            <div class="small text-muted mb-0">
                                                                <i class="mdi mdi-briefcase-outline text-info mr-1"></i>
                                                                {{ item.candidateJob ? item.candidateJob.name : '--' }}
                                                            </div>
                                                            <div class="small text-muted mb-0">
                                                                <i class="mdi mdi-email-send-outline text-info mr-1"></i>
                                                                {{ item.email ?? '--' }}
                                                            </div>
                                                            <div class="small text-muted mb-0">
                                                                <i class="mdi mdi-phone text-info mr-1"></i>
                                                                {{ item.phoneNumber ? `${item.phoneCode ?? ''} ${item.phoneNumber}`.trim() : '--' }}
                                                            </div>
                                                            <div class="small text-muted">
                                                                <i class="mdi mdi-calendar text-info mr-1"></i>
                                                                {{ item.createdAt || '--' }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <b-alert
                                                v-if="tableRows.length == 0"
                                                show
                                                variant="warning"
                                                class="mt-0 text-center"
                                            >
                                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                                            </b-alert>
                                        </template>
                                    </div>
                                    <div v-if="totalPage" class="card-footer bg-white">
                                        <div class="row">
                                            <div class="col d-flex justify-content-center mb-2">
                                                <small>Total: {{ totalPage }}</small>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col d-flex justify-content-center">
                                                <b-pagination
                                                    v-model="currentPage"
                                                    :total-rows="totalPage"
                                                    :per-page="perPage"
                                                    v-on:change="pageNavigation"
                                                    size="sm"
                                                    align="center"
                                                    class="mb-0"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="selectedCandidate"
                                :key="selectedCandidate.uuid"
                                class="col-lg-9 fade-in"
                            >
                                <div class="card border border-light">
                                    <div class="candidate-detail-scroll fade-in">
                                        <div class="m-3">
                                            <div class="row align-items-start">
                                                <div class="col-12 col-lg-8">
                                                    <div class="row align-items-start">
                                                        <div class="col-auto">
                                                            <span
                                                                v-if="!selectedCandidate.imageUrl"
                                                                :class="[
                                                                    'avatar-title rounded-circle font-size-16',
                                                                    `bg-soft-${avatarColor(selectedCandidate.firstName)}`,
                                                                    `text-${avatarColor(selectedCandidate.firstName)}`
                                                                ]"
                                                                style="width: 48px; height: 48px;"
                                                            >
                                                                {{ selectedCandidate.firstName ? selectedCandidate.firstName.charAt(0).toUpperCase() : '-' }}
                                                            </span>
                                                            <img
                                                                v-else
                                                                :src="selectedCandidate.imageUrl"
                                                                v-on:click.stop="openImageModal(selectedCandidate)"
                                                                class="rounded-circle cursor-pointer"
                                                                style="width: 48px; height: 48px; object-fit: cover;"
                                                            />
                                                        </div>
                                                        <div class="col">
                                                            <div class="row">
                                                                <div class="col-12">
                                                                    <h5 class="font-weight-bold mb-2">
                                                                        {{ `${selectedCandidate.firstName || ''} ${selectedCandidate.lastName || ''}`.trim() }}
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                            <div class="row align-items-center">
                                                                <div class="col-auto">
                                                                    <div class="text-muted">
                                                                        <i class="mdi mdi-calendar mr-1"></i>
                                                                        {{ selectedCandidate.createdAt || '--' }}
                                                                    </div>
                                                                </div>
                                                                <div class="col-auto">
                                                                    <b-badge variant="info">
                                                                        {{ selectedCandidate.candidateStatus?.name || 'N/A' }}
                                                                    </b-badge>
                                                                </div>
                                                                <div class="col-auto">
                                                                    <b-badge
                                                                        :variant="selectedCandidate.isApplicationCompleted ? 'success' : 'warning'"
                                                                    >
                                                                        <i :class="['mdi mr-1', selectedCandidate.isApplicationCompleted ? 'mdi-checkbox-marked-circle' : 'mdi-progress-clock']"></i>
                                                                        Application {{ selectedCandidate.isApplicationCompleted ? 'Completed' : 'Incomplete' }}
                                                                    </b-badge>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-4 mt-3 mt-lg-0">
                                                    <div class="row justify-content-lg-end">
                                                        <div class="col-auto">
                                                            <b-button
                                                                variant="danger"
                                                                v-b-tooltip.hover
                                                                title="Export PDF"
                                                                :disabled="!status.save"
                                                                @click="requestExportPdf(selectedCandidate)"
                                                            >
                                                                <i class="mdi mdi-file-pdf-box"></i>
                                                            </b-button>
                                                        </div>
                                                        <div class="col-auto pl-0">
                                                            <router-link
                                                                :to="{ name: 'CandidateApplication', query: { candidate: selectedCandidate.uuid } }"
                                                                target="_blank"
                                                                class="btn btn-primary"
                                                                :class="{ disabled: selectedCandidate.isApplicationCompleted }"
                                                                v-b-tooltip.hover
                                                                title="Application Form"
                                                                :style="{
                                                                    pointerEvents: selectedCandidate.isApplicationCompleted ? 'none' : 'auto',
                                                                    cursor: selectedCandidate.isApplicationCompleted ? 'not-allowed' : 'pointer'
                                                                }"
                                                            >
                                                                <i class="mdi mdi-file-document-outline"></i>
                                                            </router-link>
                                                        </div>
                                                        <div class="col-auto pl-0">
                                                            <b-button
                                                                variant="info"
                                                                v-b-tooltip.hover
                                                                :title="$t('label.updateX', [])"
                                                                v-on:click="openForm(selectedCandidate)"
                                                            >
                                                                <i class="mdi mdi-pencil"></i>
                                                            </b-button>
                                                        </div>
                                                        <div class="col-auto pl-0">
                                                            <b-button
                                                                variant="warning"
                                                                v-b-tooltip.hover
                                                                title="Update Application"
                                                                v-on:click="openApplicationForm(selectedCandidate)"
                                                            >
                                                                <i class="mdi mdi-account-edit-outline"></i>
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mx-3 overflow-auto">
                                            <ul class="nav nav-tabs flex-nowrap">
                                                <li
                                                    v-for="(item, index) of candidateTabOptions"
                                                    :key="index"
                                                    class="nav-item"
                                                >
                                                    <a
                                                        href="javascript:void(0);"
                                                        :class="['nav-link small py-2 px-3 text-nowrap', item.value == candidateTabActive ? 'active text-info' : '']"
                                                        v-on:click="candidateTabActive = item.value"
                                                    >
                                                        <i :class="['mdi mr-1', item.icon]"></i>
                                                        {{ item.name }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="m-3">
                                            <CandidatePersonal
                                                v-if="candidateTabActive == 1"
                                                :candidate="selectedCandidate"
                                            />
                                            <CandidateExperience
                                                v-if="candidateTabActive == 2"
                                                :experiences="selectedCandidate.candidateExperiences"
                                            />
                                            <CandidateEducation
                                                v-if="candidateTabActive == 3"
                                                :educations="selectedCandidate.candidateEducations"
                                            />
                                            <CandidateFamily
                                                v-if="candidateTabActive == 4"
                                                :families="selectedCandidate.candidateFamilies"
                                            />
                                            <CandidateLanguage
                                                v-if="candidateTabActive == 5"
                                                :languages="selectedCandidate.candidateLanguages"
                                            />
                                            <CandidateMedical
                                                v-if="candidateTabActive == 6"
                                                :medical="selectedCandidate.candidateMedical"
                                            />
                                            <CandidateStatusLog
                                                v-if="candidateTabActive == 7"
                                                :statusLogs="selectedCandidate.candidateStatusLogs"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                            <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                        </div>
                        <b-modal
                            id="candidate-application-form"
                            title="Update Application"
                            @hidden="closeApplicationForm"
                            hide-footer
                            hide-header-close
                            centered
                            size="lg"
                        >
                            <b-container fluid>
                                <CandidateApplicationForm
                                    :candidateUUID="candidateApplication.uuid"
                                    :searchCriteria="searchCriteria"
                                    @done="closeApplicationForm(); $emit('done')"
                                    ref="candidateApplicationForm"
                                />
                            </b-container>
                        </b-modal>
                        <b-modal
                            id="candidate-form"
                            :title="$t(candidate.uuid ? 'label.updateX' : 'label.createX', [$t('module.candidate')])"
                            @hidden="closeForm"
                            hide-footer
                            hide-header-close
                            centered
                            size="xl"
                        >
                            <b-container fluid>
                                <CandidateForm
                                    :candidateUUID="candidate.uuid"
                                    :candidateStatusUUID="candidateStatus"
                                    :searchCriteria="searchCriteria"
                                    @done="closeForm(); $emit('done')"
                                    @close="closeForm()"
                                    ref="candidateForm"
                                />
                            </b-container>
                        </b-modal>
                        <b-modal
                            id="candidate-delete"
                            :title="candidate.isActive == 0 ? $t('label.restoreX', []) : $t('label.deleteX', [])"
                            @hidden="closeForm"
                            hide-header-close
                        >
                            <p class="my-4">
                                {{ candidate.isActive == 0 ? $t('message.restoreConfirmation') : $t('message.deleteConfirmation') }}
                            </p>
                            <template #modal-footer>
                                <b-button
                                    variant="danger"
                                    class="col-2"
                                    @click="$bvModal.hide('candidate-delete')"
                                >
                                    {{ $t('label.cancel') }}
                                </b-button>
                                <b-button
                                    variant="info"
                                    class="ml-2 col-2"
                                    v-on:click="requestDelete"
                                    :disabled="!status.save"
                                >
                                    {{ candidate.isActive == 0 ? $t('label.restoreX', []) : $t('label.deleteX', []) }}
                                </b-button>
                            </template>
                        </b-modal>
                        <b-modal
                            id="candidate-image"
                            :title="$t('label.viewX', [$t('label.image')])"
                            @hidden="closeForm"
                            centered
                            size="lg"
                            hide-header-close
                        >
                            <b-container fluid>
                                <div class="col-12">
                                    <div class="row d-flex justify-content-center border border-light shadow-lg m-1 p-3 rounded">
                                        <img
                                            :src="candidate.image"
                                            style="max-width: 100%; max-height: 600px;"
                                        />
                                    </div>
                                </div>
                            </b-container>
                            <template #modal-footer>
                                <b-button
                                    variant="danger"
                                    class="col-2"
                                    @click="$bvModal.hide('candidate-image')"
                                >
                                    {{ $t('label.cancel') }}
                                </b-button>
                            </template>
                        </b-modal>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { SESSION, SHARED } from "@/constants";
import { sessionHelper } from "@/utils";
import { mapState } from "vuex";
import { candidateMethods } from "@/state/api";
import { CANDIDATE_MODULE } from "@/state/api/candidate.state";
import CandidatePersonal from "@/views/pages/admin/candidate/candidatePersonal";
import CandidateExperience from "@/views/pages/admin/candidate/candidateExperience";
import CandidateEducation from "@/views/pages/admin/candidate/candidateEducation";
import CandidateFamily from "@/views/pages/admin/candidate/candidateFamily";
import CandidateLanguage from "@/views/pages/admin/candidate/candidateLanguage";
import CandidateMedical from "@/views/pages/admin/candidate/candidateMedical";
import CandidateStatusLog from "@/views/pages/admin/candidate/candidateStatusLog";
import CandidateForm from "@/views/pages/admin/candidate/candidateForm";
import CandidateApplicationForm from "@/views/pages/admin/candidate/candidateApplicationForm";

export default {
    props: {
        candidateStatus: {
            type: String,
            required: false,
        },
    },
    components: { CandidatePersonal, CandidateExperience, CandidateEducation, CandidateFamily, CandidateLanguage, CandidateMedical, CandidateStatusLog, CandidateForm, CandidateApplicationForm },
    created() {
        sessionHelper.clearSearch(SESSION.CANDIDATE_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();

        this.loading = false;
    },
    data() {
        return {
            filter: "",
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            isActive: { value: 1 },
            selectedCandidateUUID: null,
            searchCriteria: {},
            candidate: {
                uuid: "",
                isActive: false,
                image: null,
            },
            candidateApplication: {
                uuid: "",
            },
            candidateTabOptions: [
                {value: 1, icon: 'mdi-account-outline', name: "Personal"},
                {value: 2, icon: 'mdi-briefcase-outline', name: "Experience"},
                {value: 3, icon: 'mdi-school-outline', name: "Education"},
                {value: 4, icon: 'mdi-account-group-outline', name: "Family"},
                {value: 5, icon: 'mdi-translate', name: "Language"},
                {value: 6, icon: 'mdi-medical-bag', name: "Medical"},
                {value: 7, icon: 'mdi-history', name: "Status Log"},
            ],
            candidateTabActive: 1,
            loading: true,
        };
    },
    methods: {
        ...candidateMethods,
        initSearchCriteria() {
            let isDefault = true;
            if (sessionHelper.hasSearchCriteria(SESSION.CANDIDATE_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.CANDIDATE_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }
            if (isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    isActive: this.isActive.value,
                    searchValue: "",
                    searchArray: [],
                };
            }

            if (this.candidateStatus) this.searchCriteria.candidateStatus = this.candidateStatus;

            this.getCandidateList(this.searchCriteria);
        },
        getCandidateList(filter) {
            this.getAllCandidate({ filter })
                .then((result) => this.$nextTick(() => {
                    if (result?.success) {
                        this.selectedCandidateUUID = this.tableRows.find((item) => item.uuid == this.selectedCandidateUUID)?.uuid || this.tableRows[0]?.uuid || null;
                    }
                }));
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.CANDIDATE_SEARCH, filter);
        },
        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.CANDIDATE_SEARCH);
            filter.pageNumber = pageNumber;
            this.getCandidateList(filter);
        },
        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            this.searchCriteria.isActive = this.isActive.value;
            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }

            if (this.candidateStatus) this.searchCriteria.candidateStatus = this.candidateStatus;

            this.getCandidateList(this.searchCriteria);
        },
        deleteConfirmation(data) {
            this.candidate = {
                uuid: data.uuid,
                isActive: data.isActive,
            };
            this.$bvModal.show('candidate-delete');
        },
        requestDelete() {
            let data = {
                uuid: this.candidate.uuid,
                isActive: this.candidate.isActive == 0 ? 1 : 0,
            };
            this.updateCandidateStatus({ data, filter: this.searchCriteria })
                .then((result) => this.$nextTick(() => {
                    if (result?.success) this.$bvModal.hide('candidate-delete');
                }));
        },
        openForm(data) {
            if (data?.uuid) {
                this.candidate = {
                    uuid: data.uuid,
                    isActive: data.isActive,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('candidate-form');
            });
        },
        openApplicationForm(data) {
            this.candidateApplication = {
                uuid: data.uuid,
            };
            this.$nextTick(() => {
                this.$bvModal.show('candidate-application-form');
            });
        },
        closeApplicationForm() {
            this.candidateApplication = {
                uuid: "",
            };
            this.$bvModal.hide('candidate-application-form');
        },
        closeForm() {
            this.candidate = {
                uuid: "",
                isActive: false,
                image: null,
            };
            this.$bvModal.hide('candidate-form');
            this.$bvModal.hide('candidate-delete');
        },
        openImageModal(data) {
            if (data?.imageUrl) {
                this.candidate = {
                    uuid: data.uuid,
                    image: data.imageUrl,
                };
                this.$bvModal.show('candidate-image');
            }
        },
        requestExportPdf(data) {
            this.exportCandidatePdf({data: {uuid: data.uuid}})
                .then((result) => {
                    if (result instanceof Blob) {
                        const url = URL.createObjectURL(result);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = `candidate-${data.uuid}.pdf`;
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        setTimeout(() => URL.revokeObjectURL(url), 1000);
                    }
                });
        },
        avatarColor(item) {
            const colors = ['primary', 'success', 'danger', 'warning', 'info'];
            if (!item) return 'secondary';
            return colors[item.length % colors.length];
        },
    },
    computed: {
        ...mapState(CANDIDATE_MODULE, ['status']),
        tableRows() {
            return this.$store.state.api.candidate.list.data || [];
        },
        totalPage() {
            return this.$store.state.api.candidate.list.pagination.total || 0;
        },
        selectedCandidate() {
            return this.tableRows.find((item) => item.uuid == this.selectedCandidateUUID) || this.tableRows[0] || null;
        },
    },
}
</script>
<style scoped>
    .candidate-list-scroll {
        height: calc(100vh - 500px);
        min-height: 400px;
        overflow-y: auto;
    }

    .candidate-detail-scroll {
        height: calc(100vh - 370px);
        min-height: 400px;
        overflow-y: auto;
    }

    .candidate-card {
        transition: box-shadow 0.2s ease-in-out, border-color 0.15s ease-in-out;
    }

    .candidate-card:hover {
        border-color: #007bff;
        box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.08) !important;
    }

    @media (max-width: 991.98px) {
        .candidate-list-scroll,
        .candidate-detail-scroll {
            height: auto;
            min-height: 0;
            overflow-y: visible;
        }
    }

    .ribbon-wrapper {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 90px;
        overflow: hidden;
        pointer-events: none;
        z-index: 2;
    }

    .ribbon {
        position: absolute;
        top: 24px;
        right: -42px;
        width: 150px;
        transform: rotate(45deg);
        text-align: center;
        font-size: 0.62rem;
        line-height: 1.1;
        padding: 5px 0;
        color: #856404;
        background: #fff3cd;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
    }
</style>
